module.exports = __webpack_public_path__ + "static/images/cover_C9.8babd99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C9.png
// module id = /VcX
// module chunks = 8